<template>
  <a-layout id="components-layout-demo-custom-trigger">

    <Sidebar></Sidebar>

    <a-layout>
      <a-layout-content
          :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '100vh'}">
        <a-row :style="{margin:'5px'}">
          <a-col :span="12">
            <h2>Campaigns</h2>
          </a-col>
          <a-col :span="12" :style="{textAlign:'end'}">
            <a-button type="primary" @click.prevent="fetchData(false)">
              <a-icon type="reload" />
              Refresh
            </a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" :style="{background:'#fff'}">
            <div class="card-container">
              <a-tabs type="card" @change="fetchData">
                <a-tab-pane key="sending">
                <span slot="tab">
                 <a-icon type="play-circle" />
                  Sending
                </span>

                  <CampaignList :type="'active'" ref="sendingList"></CampaignList>

                </a-tab-pane>
                <a-tab-pane key="scheduled">
                  <span slot="tab">
                   <a-icon type="clock-circle" />
                    Schedule
                  </span>

                  <CampaignList :type="'scheduled'" ref="scheduledList"></CampaignList>

                </a-tab-pane>
              </a-tabs>
            </div>
          </a-col>
        </a-row>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import CampaignList from "@/components/Campaigns/CampaignList.vue";

export default {
  data() {
    return {
      loading: false,
      activeKey: 'sending',
    };
  },
  components: {
    Sidebar,
    CampaignList
  },
  methods: {
    fetchData(activeKey) {
      if (activeKey) {
        this.activeKey = activeKey;
      }

      if (this.activeKey === 'sending') {
        this.$refs.sendingList.search();
      } else if (this.activeKey === 'scheduled') {
        if (this.$refs.scheduledList) {
          this.$refs.scheduledList.search();
        }
      }
    }
  }
};
</script>